import React, {useRef} from 'react'
import gql from 'graphql-tag'
import {Mutation} from 'react-apollo'
import DeletableAssetThumb from './DeletableAssetThumb'
import {getInputAssetsQuery} from './'

const deleteInputAssetMutation = gql`
  mutation DeleteInputAsset($id: ID!) {
    DeleteInputAsset(id: $id) {
      deletedId
    }
  }
`

const ExistingAssets = ({product, assets, description, onLoadingChanged}) => {
  // Keep track of assets being deleted so parent component can be notified
  // in order to keep a global loading state.
  const deleting = useRef({})
  const markAssetDeleting = (asset, isDeleting) => {
    deleting.current = {...deleting.current, [asset.id]: isDeleting}
    onLoadingChanged(Object.values(deleting.current).some(a => a))
  }

  if (assets.length === 0 && description) {
    return (
      <div className="existing-assets">
        {description}
      </div>
    )
  }

  return (
    <div className="existing-assets">
      <p>Når du har lastet opp alle relevante filer må du sende det videre til produksjon.</p>
      <div className="deletable-asset-thumb-wrapper">
        {assets.map((asset) => (
          <Mutation
            key={asset.id}
            mutation={deleteInputAssetMutation}
            refetchQueries={[{
              query: getInputAssetsQuery,
              variables: {productId: product.id},
            }]}
          >
            {(deleteInputAsset, {loading: isDeleting}) => (
              <DeletableAssetThumb
                asset={asset}
                isDeleting={isDeleting}
                onDelete={() => {
                  markAssetDeleting(asset, true)
                  return deleteInputAsset({
                    variables: {
                      id: asset.id,
                    }
                  })
                  .then(() => markAssetDeleting(asset, false))
                  .catch(() => markAssetDeleting(asset, false))
                }}
              />
            )}
          </Mutation>
        ))}
      </div>
    </div>
  )
}

export default ExistingAssets
